import { render } from "./SelectPer.vue?vue&type=template&id=46220bc4&scoped=true"
import script from "./SelectPer.vue?vue&type=script&lang=js"
export * from "./SelectPer.vue?vue&type=script&lang=js"

import "./SelectPer.vue?vue&type=style&index=0&id=46220bc4&lang=scss&scoped=true"
import "./SelectPer.vue?vue&type=style&index=1&id=46220bc4&lang=css"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46220bc4"]])

export default __exports__